export default {
  YES: 'yes',
  NO: 'no',
  SAVE: 'Save',
  RESET: 'Reset',
  APPLY: 'Apply',
  EXPORT_CONFIG: 'Export Configurations',
  IMPORT_CONFIG: 'Import Configurations',
  CHOOSE: 'Please choose',
  UPLOAD: 'Upload',
  CUSTOM: 'Custom',
  EDIT: 'Edit',
  COMPLETE: 'Complete',
  CANCEL: 'Cancel',
  DISPLAY_NAME: 'Display Name',
  ADD: 'Add',
  EMPTY: ' ',
  PROCESSING: 'processing',
  EXPORTING: 'exporting',
  IMPORTING: 'importing',
  ERRORCUST: 'Please upload the correct cust file',

  CONFIG_SET: 'Config Settings',
  CONTACT_SET: 'Contacts Settings',
  LAYOUT_SET: 'Layout Settings',
  BG_SET: 'Background Settings',
  LANG_KEYBOARD_SET: 'Language and Keyboard',
  SCREEN_SAVER_SET: 'Screensaver Settings',
  TASKBAR_SET: 'Taskbar Settings',
  CALL_SET: 'Call Settings',
  AUTOSIZE_SET: 'Auto Adjust Screen Settings',

  SYSTEM_MAINTENANCE: 'System Maintenance',
  APP_SET: 'App Settings',
  TOOL_SET: 'Widget Settings',
  SYSTEM_SET: 'System Settings',
  PERI_SET: 'Peripherals Settings',
  OTHER_SET: 'Other Settings',

  // phoneBook
  EXT_XML: "Please select a '.xml' file.",
  EXT_XML_ETC: "Please select a '.xml' or '.vcf' file.",
  EXT_HTML: "Please select a '.html' file.",
  EXT_CSV: "Please select a '.csv' file.",
  EXT_VCARD: "Please select a '.vcf' file.",
  SELCODE: ' You may select another encode to retry',
  DOWNSUC: 'Download succeed!',
  DOWNFAIL: 'Download failed',
  DOWNMODEOFF: 'The download mode is set to OFF',
  URLINVALID: 'Download URL is invalid, NULL or empty!',
  DOWNGUI: 'GUI is using!',
  DOWNFULL: 'The list is full',
  WILLFULL:
    'Import not processed! This will cause contacts number exceeds the maximum value:',
  DOWNPARSEFAIL: 'File parse failed!',
  FILEINVALID: 'The file format is invalid!',
  DOWNPROCESS: 'The download is processing!',
  IMPORTFAIL: 'Import failed',
  IMPORTSUC: 'Import succeed!',
  IMPORTPROCESS: 'The import is processing!',
  FILE_TYPE: 'File Type',
  FILE_ENCODE: 'File Encoding',
  ENCODEERROR:
    'File encode failed!You could change the file encoding for another try.',
  NOCONTACTEXPORT: 'No contacts can be exported!',
  DOWNSET: 'Download or load file',
  FILESRC: 'File Source',
  SRCINTERNET: 'Internet',
  SRCLOCAL: 'Local File',
  CLEAR_OLD_LIST: 'Clear the Old List',
  CLEAR_OLD_LIST_MODE: 'Clear Old History Mode',
  CLEAR_ALL: 'Clear all',
  REPLACE_DUP: 'Replace Duplicate Items',
  REPLACE_DUP_MODE: 'Replace Duplicate Entries Mode',
  REPLACE_BY_NAME: 'Replace by name',
  REPLACE_BY_NUMBER: 'Replace by number',
  KEEP_LOCAL_CONTACTS: 'Keep Local Contacts',
  DOWNDUPYES: 'Yes ',
  DOWNLOAD_MODE: 'Download Mode',
  DOWNLOAD_MODE_OFF: '关闭',
  SAVEFAV: 'Save Favorites to PC',
  DOWNLOAD_SERVER: 'Download Server',
  DOWNLOAD_SERVER_EMPTY: "Download server can't be empty!",
  DOWNNOW: 'Download Now',
  DOWNLOAD: 'Download',
  LOCALFILE: 'Local File',
  BROWSE: 'Browse',
  DOWNBS: 'Download BS contacts',
  SAVEPHONE: 'Save the phone to the computer',
  AUTO_DOWNLOAD_INTERFAL: 'Automatic Download Interval',
  IMEXPORT: 'import/export',
  IMPORT: 'Import',
  EXPORT: 'Export',
  NAME: 'name',
  PASSWORD: 'password',
  NONE: 'none',
  HOUR: '{n} Hour',
  HOURS: '{n} Hours',
  LDAP_AND_CALLLOG: 'Contacts',
  SHOW_LDAP: 'Display LDAP Contacts',
  SHOW_CALLLOG: 'Display Local Call History',
  BSCALLTIME: 'BS CallLog Interval',
  HTTP_HTTPS_USERNAME: 'HTTP/HTTPS User Name',
  HTTP_HTTPS_PASSWORD: 'HTTP/HTTPS Password',
  ICE_CONTACT: 'ICE Contact',
  ICE_CONTACT_ERROR: 'The contact number already exists.',

  // tools
  DTMFLARGE: 'DTMF按钮大小',
  DTMFCOLOR: 'DTMF按钮颜色',
  SHOWIP: '显示IP地址',
  BIG: '大',
  MIDDLE: '中',
  SMALL: '小',
  RED: '红色',
  YELLOW: '黄色',
  GRAY: '灰色',
  BLUETOOTH: '蓝牙',
  LIGHT: '亮度',
  NODISTURB: '免打扰',
  LOCKSCREEN: '锁屏',

  // taskbar
  DISABLE_TASKBAR: ' Disable Taskbar',
  TASK_TITLE1: 'Selected',
  TASK_TITLE2: 'Available',
  WIFI: 'Wi-Fi',
  BT: 'Bluetooth',
  GS_DND: 'DND',
  GS_VOICE: 'Voice',
  GS_AUDIO: 'Audio Calibration',
  GS_LOCK: 'Screen off',
  GS_AUTOANSWER: 'Auto answer',
  GS_TRANSFER: 'Call forward',
  GS_HOTSPOT: 'Hotspot',
  GS_EHS: 'RJ9 headset',
  GS_SCREENSHOT: 'Screenshot',
  GS_NETWORK: 'Network status',
  TASKPROMPT: 'Drag icons to reorder',
  TASKBOX_PROMPT1: 'Drag icons to adjust order, click "-" to delete',
  TASKBOX_PROMPT2: 'Click "+" to add to the taskbar',

  // language
  LANG_SET: 'Language Setting',
  LANG_SELECT: 'Select Language',
  DEF_INPUT_METHOD: 'Default Input Method',
  CUSTOM_LANG: 'Custom Language',
  CUSTOM_INPUT_METHOD: 'Custom Input Method',
  ANDROID_KEY: 'Android Keyboard(AOSP)',
  GOOGLE_PINYIN: 'Google Pinyin IME',
  // screen
  SCREEN_SAVER_TYPE: 'Screensaver Type',
  SCREEN_SAVER_DEFAULT: 'Default Screensaver',
  SCREEN_SAVER_CLOCK: 'Clock Screensaver',
  SCREEN_SAVER: 'Screensaver',
  SCREEN_SAVER_TIME: 'Screensaver Timeout',
  SCREEN_SAVER_LCDOFF: 'Screen Timeout',
  SCREEN_SAVER_INTERVAL: 'Interval Between Every Two Picture',
  FORCE_ORIENTATION: 'Landscape screen',
  DEFAULT_DIR: 'Default Folder',
  LOCAL_IMG: 'Local Pictures',
  NET_IMG: 'Internet Picture',
  NET_IMG_ADDRESS: 'Internet Pictures',
  SECONDS: '{n} Seconds',
  MINUTE: '{n} Minute',
  MINUTES: '{n} Minutes',
  NEVER: 'Never',
  TYPE: 'Style',
  DIGIT_CLOCK: 'Digital Clock',
  ANALOG_CLOCK: 'Analog Clock',
  NIGHT_MODE: 'Night Mode',
  // layout
  DIALPAD_SHOW: 'Display Dialpad',
  DIA_DESK_MANAGE: 'Disable Desktop Management',
  DIA_DESK_BTN: 'Disable Touch Buttons',
  DIS_REMOVE_WIDGET: 'Disable Removal of Desktop Widgets',
  APP_INSTALL_SCREEN: 'App Install Screen',
  ADD_APP: 'Add App',
  ADD_WIDGET: 'Add Widget',
  DEL_PAGE_WARN: 'This interface has content and cannot be deleted',
  DEL_PAGE_WARN2: 'This interface cannot be deleted',
  ADD_PAGE_WARN: "Can't add more pages",
  AREA_WARN: 'Not in the active area',
  NO_APP: 'No more applications',
  NO_WIDGET: 'No more widgets',
  OVERLAP_WARN: 'Do not overlap',
  NOSPACE_WARN: 'No suitable location',
  REAPTAPP_WARN: 'The app already exists',
  NEW_FOLDER: 'Add folder',
  UNNAMED_FOLDER: 'Unnamed Folder',
  CANNOT_REMOVE_FOLDER: 'This folder has content and cannot be deleted',
  PRESENTATION: 'Presentation',
  // background
  DISABLE_CHANGE_WALLPAPER: 'Not Allow Changing Wallpaper',
  ADD_BACKGROUND: 'Select Image',
  IMG_ERROR:
    'Please upload file in correct format (.jpg/.svg/.png/.jpeg/.bmp).',

  URL: 'URL',
  UNNAME_BOOKMARK: 'Unnamed bookmark',
  SC_NAME: 'Name',
  SC_NAME_ERR_TIP: 'Please enter the bookmark name',
  URL_ERROR_TIP: 'Please enter the URL in the correct format',
  // app
  OTHER: '其他',
  ACCONT22: '帐号(2X2)插件',
  ACCONT42: '帐号(4X2)插件',
  ACCONT43: '帐号(4X3)插件',
  ACCONTFIXED: '帐号(固定的)插件',
  FILEMANAGER: 'File Manager',
  BROWSER: 'Browser',
  DOWNLOADS: '下载内容',
  GALLERY: '图库',
  BLACKLIST: '黑名单',
  MESSAGE: 'Message',
  PHONE: 'Phone',
  CALLHISTORY: 'Call History',
  CONTACTS: 'Contacts',
  SETTINGS: 'Settings',
  GSMARKET: 'GSMarket',
  MARKET: 'GSMarket',
  PNP: '智能配置',
  BROADSOFT_XMPP: 'BS-IM&P',
  MUSIC: '音乐',
  EMAIL: '电子邮件',
  DIAGNOSIS: '出厂设置',
  IP_LOCATION: 'IP定位',
  LYNC_SETUP: 'Lync设置导向',
  CALENDAR: '日历',
  CALCULATION: 'Calculation',
  CALCULATOR: 'Calculation',
  CLOCK: 'clock',
  BACKUP: 'Backup and restore',
  CAMERA: 'Camera',
  CONF: 'Conference',
  CONFERENCE: 'Conference',
  FTP_SERVER: 'FTP Server',
  MPK: 'MPK',
  RECORDER: 'Recorder',
  VOICEMAIL: 'Voice Mail',
  MPK61: 'MPK(6X1)插件',
  MPK41: 'MPK(4X1)插件',
  MPK21: 'MPK(2X1)插件',
  BOOKMARKS22: '书签(2X1)插件',
  DIGITAL_CLOCK: 'Digital Clock',
  ANALOG_CLOCKS: 'Analog Clock',
  CALENDAR_APPLET: '日历插件',
  MUSIC_APPLET: '音乐插件',
  RSSNEWS_APPLET: 'RSS新闻插件',
  PHONE_WIDGET: '拨号窗口',
  WEATHER_FORECAST: 'Weather Forecast',
  WEATHER: 'Weather Forecast',
  SYSTEM_SETTINGS51: '系统设置(5X1)插件',
  SYSTEM_SETTINGS31: '系统设置(3X1)插件',
  ADD_THIRD_APP: 'Add 3rd Party App',
  APK_NAME: 'Apk Name',
  APK_ERROR: 'Invalid apk file',
  TIMEOUT: 'Processing timeout',
  APK_EMPTY: 'Display name can not be empty',
  XSI: 'XSI',
  IP_WIDGET: 'System status',
  PAGE_MPK: 'Page Programmable Key',
  XMPP: 'BS-IM&P',
  STATE_DETECTION: 'Diagnostics',
  BOOKMARK: 'Bookmark',
  UPLOAD_APK_ERROR: 'Please upload apk file',
  BOOT_TYPE: 'Launch after Booting',
  BOOT: 'Yes',
  NOBOOT: 'No',
  BOOT_NETWORK: 'Launch after network connected',
  APP_AUTOLAUNCH: 'Auto launch when no operation',
  INTERVAL_WITHOUT_OPERATE: 'Intervals without operation',
  SHOW_ICON: 'Show App Icon',
  DEVICE_OWNER_CLASS: 'Device Owner Class',
  OWNER_CLASS_NONE: 'None',
  // tooltips
  INSTRUCTIONS: 'Operation Instructions',
  CONFIG_SET_TIP:
    'Enable/Disable settings. After disabling,this setting item is inoperable during this configuration and will not be updated into the configuration file.',
  CONTACT_SET_TIP:
    'Configure the default setting for the phone to import/export/download contacts.',
  CONTACT_SET_TIP2: 'Configure the default emergency call number.',
  BACKGROUND_SET_TIP: 'Configure the default wallpaper.',
  BACKGROUND_SET_TIP2: 'Enable/Disable users to manually change wallpapers.',
  LAYOUT_TIP_TITLE1: 'Set the Default Desktop Home Page',
  LAYOUT_TIP1:
    'Click the number on the right to switch pages, and click the home icon in the upper left corner to set the desktop default home page.',
  LAYOUT_TIP_TITLE2: 'Change Desktop Order',
  LAYOUT_TIP2:
    'Select a desktop, then click the up and down keys in the upper right corner to change the desktop order.',
  LAYOUT_TIP_TITLE3: 'Increase/Decrease Desktop',
  LAYOUT_TIP3:
    'Click “+”/”-”below the number to increase/decrease the desktop.',
  LAYOUT_TIP_TITLE4: 'Desktop Layout',
  LAYOUT_TIP4:
    'The layout of the configuration includes the main screen, apps, widgets and the navigation bar.',
  LAYOUT_TIP42:
    'Select the target desktop, press and hold the application icon or widget to drag it from the desktop to the app candidate or to drag from the app candidate to the desktop.',
  LAYOUT_TIP_TITLE5: 'Add a 3rd-Party Application',
  LAYOUT_TIP5:
    'Click “Upload” button, then upload the apk file. The 3rd-party application with the icon and name will be displayed on the panel.',
  LAYOUT_TIP_TITLE6: 'Add folder',
  LAYOUT_TIP6:
    'Click "Add folder" to add an application folder on the selected desktop. Press and hold the application icon to drag it from desktop into the folder.',
  LAYOUT_TIP62:
    "Double-click and open the folder to view the applications and edit the folder name. Click '×' button in the upper right corner of the application icon to delete it from the folder and display it on the desktop in order from left to right and top to bottom. If there is no enough space, it can not be deleted.",
  LAYOUT_TIP63:
    'Note: If less than two applications are in the folder, no folder will be displayed when configured to the phone.',
  SCREENSETTIP: 'Configure the default screensaver function of the phone.',
  LANGUAGE_SET_TIP: 'Configure the default language and input method.',
  TASKBAR_SET_TIP: 'Drag the icon to adjust the order of items in the taskbar.',
  TASKBAR_SET_TIP2: 'Click “-” to close the enabled status of the item.',
  TASKBAR_SET_TIP3: 'Click “+” to enable this setup.',
  CALL_TIP_TITLE1: 'Add Display Items',
  CALL_TIP1:
    'Select the items from the left menu bar and click the “Add to the right” button. Select up to 4 items.',
  CALL_TIP1_3350:
    'Select the items from the left menu bar and click the “Add to the right” button. Select up to 2 items.',
  CALL_TIP_TITLE2: 'Replace Display Items',
  CALL_TIP2:
    'Select the items you do not need from the right menu bar, click “Add to the Left” button, then select the items you need from the left menu bar to join the right side.',
  CALL_TIP3: 'Press and hold an item to adjust its position in the menu bar.',
  CALL_TIP4:
    'Display up to 4 items. When there are less than 4 items displayed, it will select left menu items from top to bottom to display in the call screen.',
  CALL_TIP4_3350:
    'Display up to 2 items. When there are less than 2 items displayed, it will select left menu items from top to bottom to display in the call screen.',
  ADJUST_SCREEN_TIP:
    'The list shows all third-party applications that support screen adaptation function. You can select the applications that you need from the list.',
  // 新功能说明
  CLOSE: 'Close',
  NEW_FUNCTION: ' New Function Instructions',
  NEW_FUNCTION1: 'New Features Note',
  NEW_FUNCTION_TEXT1: 'The current configuration file adapts to the',
  NEW_FUNCTION_TEXT2:
    'version of the phone. To ensure the validity of the configuration file and avoid configuration errors, please make sure that the firmware version of the terminal phone has been upgraded to',
  NEW_FUNCTION_TEXT3: 'and above!',
  NEW_FUNCTION_TEXT4:
    'Add call settings configuration page, support call function buttons customization.',

  // callset
  CONFERENCE2: 'Conference',
  CALL_MUTE: 'Mute',
  CALL_KEYBOARD: 'Keyboard',
  CALL_HOLD: 'Hold',
  CALL_VIDEO: 'Start Video',
  RECORD: 'Record',
  MEDIA_CHANNEL: 'Media Channel',
  CALL_TRNF: 'Transfer',
  CALL_DETAIL: 'Call Details',
  NEW_CALL: 'New Call',
  SRTP: 'SRTP',
  CALL_CENTER: 'Call Center',
  CALL_UCMROOM: 'UCM Conference Room',
  CALL_UCMMENU: 'UCM Conference Menu',
  INVITE: 'Invite',
  SOURCE_TITLE: 'Items in "More"',
  TARGET_TITLE: 'Displayed Items',
  CALLSET_TRANSFER_ERROR: 'Display up to {n} items',
  AVAILABLE: 'Available',
  SELECTED: 'Selected',
  CALLSET_WARNING:
    'When less than {n} items are displayed, it will be displayed from top to bottom in "More".',
  ONEWAY_TITLE: 'One-Way Call Function Buttons',
  ONEWAY_PROMPT:
    'The "Displayed Items" will be directly displayed in the call screen, with {n} items by default. Other items are hidden by default in "More".',
  CON_TITLE: 'Conference Call Function Buttons',
  CON_PROMPT:
    'The "Displayed Items" will be directly displayed in the conference call screen, with {n} items by default. Other items are hidden by default in "More".',
  EXPLAIN: 'Explain',
  // transfer
  ITEM: 'item(s)',
  APPLIST: 'Application List',

  UPLOAD_SUCCESS: 'Upload success',

  WIRELESS_MIC: 'Wireless Microphone',
  GUILDLINES: 'Guidelines',
  SCHEDULE: 'Schedule',
  ENTERPRISE_DIR: 'Enterprise Directory',
  CLOCK_APP: 'Clock',

  SAVE_TO_GDMS: 'Save to GDMS',
  SAVE_FAILED: 'Save failed',
  SAVE_SUCC: 'Saved successfully',
  SAVE_FAILED_33004: 'Save failed, file already exists',
  EXPORT_FAILED: 'Export failed',

  CONF_CONTROL: 'Conference Control',

  ONE_CLICK_CONFIG: 'One-click Configuration',

  DISABLE_FOCUS_MODE: 'Disable Focus Mode',

  LDAP: 'LDAP',
  CALL_FORWARD: 'Call Forward Settings',
  MULTICAST_LISTENING: 'Multicast Listening',
};
